import { type ExtensionAttributeMappingIn } from '@/client'

export type SaasmetrixField = ExtensionAttributeMappingIn[string]
export type SaasmetrixFieldValue = Exclude<SaasmetrixField, null>

export const SAASMETRIX_EXTENSION_ATTRIBUTE_FIELDS: SaasmetrixFieldValue[] = [
  'cost_center_allocations',
  'department',
  'position',
  'employee_number',
  'country_code',
  'supervisor_remote_id',
  'phone',
  'start_date',
  'end_date',
]
